import { IIconProps } from 'src/interfaces/IconProps';

const StatsIcon = ({ width = 16, height = 12, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M0 1.5A1.5 1.5 0 0 1 1.5 0h1A1.5 1.5 0 0 1 4 1.5v9A1.5 1.5 0 0 1 2.5 12h-1A1.5 1.5 0 0 1 0 10.5v-9ZM1.5 1a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-1ZM6 7.5A1.5 1.5 0 0 1 7.5 6h1A1.5 1.5 0 0 1 10 7.5v3A1.5 1.5 0 0 1 8.5 12h-1A1.5 1.5 0 0 1 6 10.5v-3ZM7.5 7a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1ZM13.5 3A1.5 1.5 0 0 0 12 4.5v6a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 14.5 3h-1ZM13 4.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-6Z'
      fill={color}
    />
  </svg>
);

export default StatsIcon;
